import { useMutation } from "@tanstack/react-query";
import {
  updateHubungkanAkunBeliRumahCo,
  updateHubungkanAkunLamudi,
  updateHubungkanAkunRumah123,
  deleteAkunHubungkan,
} from "./api";

export const useUpdateHubungkanAkunLamudi = () => {
  return useMutation({
    mutationFn: ({ data, user_id }) => updateHubungkanAkunLamudi(data, user_id),
  });
};

export const useUpdateHubungkanAkunRumah123 = () => {
  return useMutation({
    mutationFn: ({ data, user_id }) =>
      updateHubungkanAkunRumah123(data, user_id),
  });
};

export const useUpdateHubungkanAkunBeliRumahCo = () => {
  return useMutation({
    mutationFn: ({ data, user_id }) =>
      updateHubungkanAkunBeliRumahCo(data, user_id),
  });
};

export const useDeleteAkunHubungkan = () => {
  return useMutation({
    mutationFn: ({ data, user_id }) => deleteAkunHubungkan(data, user_id),
  });
};
